import ButtonUnderText from 'components/atoms/Button/Button.underText';
import ButtonrightText from 'components/atoms/Button/Button.rightText';
import { autoCompleteState } from 'modules/actions/autoComplete';
import { changeFontSize } from 'modules/actions/fontSize';
import useRequestDM from 'modules/hooks/useRequestDM';
import { disableAllMenu } from 'modules/actions/statusMenu';
import React, {useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { chatList } from 'modules/actions/chat';
/**
 * 하단의 메뉴 컴포넌트
 * @returns {object} ChatMenu
 */
const ChatMenu = ({ styleDef }) => {
  const currentFontSize = useSelector(state => state.fontSize.size);
  const loginYN = sessionStorage.getItem('mbrId') ? 'true' : 'false';
  const dispatch = useDispatch();
  const execOnSendMsg = text => {
    const paramSet = {
      inType: 'query',
      inStr: text,
      inLabel: text,
      parameters: sessionStorage.getItem('address')
        ? {
            latitude_y: sessionStorage.getItem('latitude_y'),
            longitude_x: sessionStorage.getItem('longitude_x'),
            address: sessionStorage.getItem('address'),
            position_status: 'Y',
            login: loginYN,
            mbr_id: sessionStorage.getItem('mbrId')
          }
        : { latitude_y: '', longitude_x: '', position_status: 'N', login: loginYN, mbr_id:sessionStorage.getItem('mbrId') },
    };
    dispatch(chatList(paramSet));
    // dispatch(useRequestDM(text, 'query'));
    dispatch(disableAllMenu());
  };

  return (
    <div className="_quick_div" style={styleDef}>
      <div className="_quick_menu">
        {/* <div className="test" style={{width:"100%", height:"50px"}}>
          <ButtonrightText
            label="처음으로"
            value="처음으로"
            viewStatus=""
            styleDef={{"justifyContent": "center", "marginTop": "6px"}}
            onClickEvt={() => window.location.reload()}
            error={null}
          />
        </div> */}
        <ButtonUnderText
          label="AI 맞춤 정보"
          value="AI 맞춤 정보"
          image="/chat/images/icon_homemenu1.svg"
          viewStatus=""
          styleDef={{fontSize: `${currentFontSize}px`}}
          onClickEvt={() => execOnSendMsg('AI 맞춤 정보')}
          error={null}
          title="AI 맞춤 정보 메뉴"
        />
        <ButtonUnderText
          label="사이버 교육"
          value="사이버 교육"
          image="/chat/images/icon_homemenu2.svg"
          viewStatus=""
          styleDef={{fontSize: `${currentFontSize}px`}}
          onClickEvt={() => execOnSendMsg('사이버 교육')}
          error={null}
          title="사이버교육 메뉴"
        />
        <ButtonUnderText
          label="맞춤 지원제도 찾기"
          value="맞춤 지원제도 찾기"
          image="/chat/images/icon_homemenu3.svg"
          viewStatus=""
          styleDef={{fontSize: `${currentFontSize}px`}}
          onClickEvt={() => execOnSendMsg('맞춤 지원제도 찾기')}
          error={null}
          title="맞춤 지원제도 찾기 메뉴"
        />
        <ButtonUnderText
          label="센터 안내"
          value="센터 안내"
          image="/chat/images/icon_homemenu4.svg"
          viewStatus=""
          styleDef={{fontSize: `${currentFontSize}px`}}
          onClickEvt={() => execOnSendMsg('센터 안내')}
          error={null}
          title="센터 안내 메뉴"
        />
        <ButtonUnderText
          label="전직지원 안내"
          value="전직지원 안내"
          image="/chat/images/icon_homemenu5.svg"
          viewStatus=""
          styleDef={{fontSize: `${currentFontSize}px`}}
          onClickEvt={() => execOnSendMsg('전직지원 안내')}
          error={null}
          title="전직지원 안내 메뉴"
        />
        <ButtonUnderText
          label="자주 찾는 서비스"
          value="자주 찾는 서비스"
          image="/chat/images/icon_homemenu6.svg"
          viewStatus=""
          styleDef={{fontSize: `${currentFontSize}px`}}
          onClickEvt={() => execOnSendMsg('자주 찾는 서비스')}
          error={null}
          title="자주 찾는 서비스 메뉴"
        />
      </div>
    </div>
  );
};
ChatMenu.propTypes = {
  styleDef: PropTypes.object,
};
ChatMenu.defaultProps = {
  styleDef: {},
};
export default ChatMenu;
